export const apiRuleTypes = {
  rules: "rules"
};
